/* tslint:disable */
/* eslint-disable */
/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReplyInfo,
    ReplyInfoFromJSON,
    ReplyInfoFromJSONTyped,
    ReplyInfoToJSON,
} from './ReplyInfo';

/**
 * 
 * @export
 * @interface ReplyInfoResponse
 */
export interface ReplyInfoResponse {
    /**
     * 
     * @type {ReplyInfo}
     * @memberof ReplyInfoResponse
     */
    data: ReplyInfo;
}

export function ReplyInfoResponseFromJSON(json: any): ReplyInfoResponse {
    return ReplyInfoResponseFromJSONTyped(json, false);
}

export function ReplyInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplyInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ReplyInfoFromJSON(json['data']),
    };
}

export function ReplyInfoResponseToJSON(value?: ReplyInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ReplyInfoToJSON(value.data),
    };
}

